const ACCOUNT_PATTERN = /^(.*?)\s*-\s*(\d+)\s*(\(.*\))?\s*$/;
const INACTIVE_PATTERN = /inactive/i;
const CATEGORY_NOISE = /\b(supplier|vendor)\b/gi;

export const VENDOR_STATUSES = ["Active", "Inactive", "Test"];

export const parseVendorAccount = (vendor) => {
    const raw = (vendor?.accountNumber || "").trim();
    const match = raw.match(ACCOUNT_PATTERN);

    let category = "";
    let accountNumber = raw;
    let note = "";

    if (match) {
        category = match[1] || "";
        accountNumber = match[2] || "";
        note = match[3] || "";
    } else if (/^\d+$/.test(raw)) {
        accountNumber = raw;
    } else if (raw) {
        category = raw;
        accountNumber = "";
    }

    category = category.replace(CATEGORY_NOISE, "").replace(/\s{2,}/g, " ").trim();

    let status = "Active";
    if (INACTIVE_PATTERN.test(raw)) {
        status = "Inactive";
    } else if (/\btest\b/i.test(vendor?.name || "")) {
        status = "Test";
    }

    return { category, accountNumber, note, status };
};

export const getVendorCategories = (vendors = []) => {
    const categories = new Set();
    vendors.forEach((vendor) => {
        const { category } = parseVendorAccount(vendor);
        if (category) categories.add(category);
    });
    return [...categories].sort((a, b) => a.localeCompare(b));
};
